import type { Referrals } from './types';
import type { ReferralsResponseDto, ReferralDto } from './dto';

export function mapReferralsResponseDtoToModel(referralsResponse: ReferralsResponseDto): Referrals {
  return {
    potentialReferralsCount: referralsResponse.data.potential_referrals_count,
    referralsCount: referralsResponse.data.referrals.length,
    rewardSum: referralsResponse.data.referrals.reduce(
      (acc, nextReferral) => nextReferral.reward + acc,
      0,
    ),
    referrals: referralsResponse.data.referrals.map((referral: ReferralDto) => ({
      plan: referral.plan,
      referralId: referral.referral_id,
      referralUserId: referral.referral_user_id,
      reward: referral.reward,
      subscriptionCreated: referral.subscription_created * 1000,
    })),
  };
}
